import(/* webpackMode: "eager", webpackExports: ["default","error"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/fonts/Vazirmatn-FD-Medium.ttf\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-vazir\",\"display\":\"swap\",\"preload\":true}],\"variableName\":\"vazir\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"../../public/fonts/Vazirmatn-FD-Medium.ttf\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/Vazirmatn-FD-Medium.ttf\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-vazirFD\",\"display\":\"swap\",\"preload\":true}],\"variableName\":\"vazirFD\"}");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/aparat-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/arrow-down.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/basket.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/clip.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/close-dark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/cloud.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/cookies.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-1.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-2.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-3.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/curved-items-landing-4.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/dashboard-support.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/data.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/edit.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/enamad.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/like-filled.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/like.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/loginLock.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/my-content.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-cp.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-design.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-dev.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/op-operator.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/orders.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/payment.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/search.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/secure.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/set-blue.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sharing.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/shield.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/sort.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/support.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/telegram-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/wallet-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/app/src/components/web-vitals.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/sections/WelcomeModal.tsx");
